import {HTMLProps} from "react";

export enum TitleType {
    H1,
    H2,
    H3,
    H4,
}

export interface TitleProps extends HTMLProps<HTMLDivElement> {
    titleType?: TitleType,
}
const Title = (props: TitleProps) => {
    switch (props.titleType) {
        case TitleType.H4:
            return (
                <div className={`${props.className} text-grey--400 font-medium`}>
                    {props.children}
                </div>
            )
        // H1 is default
        default:
            return (
                <div className={`${props.className || ""} font-oswald text-black text-2xl uppercase`}>
                    {props.children}
                </div>
            )
    }
}

export default Title;